'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _typography = require('./styles/typography');

var _reactIcons = require('@rover/react-icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrimaryNavigator = function (_Component) {
    _inherits(PrimaryNavigator, _Component);

    function PrimaryNavigator(props) {
        _classCallCheck(this, PrimaryNavigator);

        var _this = _possibleConstructorReturn(this, (PrimaryNavigator.__proto__ || Object.getPrototypeOf(PrimaryNavigator)).call(this, props));

        _this.renderSelectors = _this.renderSelectors.bind(_this);
        return _this;
    }

    _createClass(PrimaryNavigator, [{
        key: 'renderSelectors',
        value: function renderSelectors() {
            var _props = this.props,
                color = _props.color,
                _onClick = _props.onClick,
                selectors = _props.selectors,
                selectorStyle = _props.selectorStyle,
                titleStyle = _props.titleStyle;


            return selectors.map(function (_ref, index) {
                var icon = _ref.icon,
                    title = _ref.title,
                    isSelected = _ref.isSelected,
                    path = _ref.path;
                return _react2.default.createElement(
                    'div',
                    {
                        key: index,
                        style: _extends({}, _typography.text, _typography.semibold, _typography.large, {
                            flex: '1 1 auto',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: isSelected ? color : 'rgba(0, 0, 0, 0)',
                            height: '100%',
                            borderLeft: index > 0 && '1px solid ' + color,
                            color: isSelected ? 'white' : color
                        }, selectorStyle),
                        onClick: function onClick(e) {
                            _onClick(path);
                        }
                    },
                    icon({ fill: '' + (isSelected ? 'white' : color) }),
                    _react2.default.createElement(
                        'div',
                        { style: _extends({ marginLeft: 10 }, titleStyle) },
                        title
                    )
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                color = _props2.color,
                buttons = _props2.buttons,
                navigatorStyle = _props2.navigatorStyle;

            var style = _extends({
                height: 40,
                border: '1px solid ' + color,
                borderRadius: 4,
                display: 'flex',
                overflow: 'hidden'
            }, navigatorStyle);
            return _react2.default.createElement(
                'div',
                { style: style },
                this.renderSelectors()
            );
        }
    }]);

    return PrimaryNavigator;
}(_react.Component);

PrimaryNavigator.propTypes = {
    color: _propTypes2.default.string.isRequired,
    navigatorStyle: _propTypes2.default.object,
    onClick: _propTypes2.default.func.isRequired,
    path: _propTypes2.default.string.isRequired,
    selectors: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        icon: _propTypes2.default.func,
        title: _propTypes2.default.string,
        isSelected: _propTypes2.default.bool
    }))
};

PrimaryNavigator.defaultProps = {
    color: '#000',
    navigatorStyle: { width: 400 },
    onClick: function onClick(path) {
        return console.log('Path: ' + path);
    },
    path: 'nopath',
    selectors: [{
        icon: _reactIcons.HomeIcon,
        title: 'TEST',
        isSelected: false
    }, {
        icon: _reactIcons.HomeIcon,
        title: 'TEST 2',
        isSelected: true
    }, {
        icon: _reactIcons.HomeIcon,
        title: 'TEST 3',
        isSelected: false
    }]
};

exports.default = PrimaryNavigator;
//# sourceMappingURL=PrimaryNavigator.js.map